module.exports = __webpack_public_path__ + "static/media/about.4e44d31d.png";